export enum PendingSubscriptionStatus {
    AWAITING = 0,
    OK = 1,
    EXPIRED = 2,
    ERROR = 3,
}